module.exports = __webpack_public_path__ + "img/logo_shanjiahoutai.931d87e8.png";